
import { Vue, Prop, Component } from "vue-property-decorator";


@Component
export default class DepartmentAssignment extends Vue {
    @Prop() date!: Date;
    @Prop() shiftCode!: string;
    @Prop() ActualStartTime!: Date;
    @Prop() isOverTime!: boolean;
    @Prop() isChargeShift!: boolean;    
}